import { Container } from 'pixi.js';
import { CircularProgressBar } from '@pixi/ui';
import { getLocalizedValue } from '@softgames/localization';
import { WinStreakMenuIconLayout } from '../../../../layouts/winStreak/WinStreakMenuIconLayout';

export class WinStreakBaseIconView extends Container {
  public readonly layout = new WinStreakMenuIconLayout();

  private readonly progressBar: CircularProgressBar;

  constructor() {
    super();

    const { root } = this.layout;

    root.props({
      parent: this,
    });

    this.progressBar = new CircularProgressBar({
      backgroundColor: 0x015cf9,
      lineWidth: 15,
      fillColor: 0x66e61d,
      fillAlpha: 1,
      backgroundAlpha: 1,
      radius: 50,
      cap: 'round',
    }).props({
      parent: this.layout.progressBarSlot,
      anchor: 0.5,
      rotation: Math.PI,
    });

    void this.startNotificationAnimation();

    this.hideTimer();
  }

  public setProgress(progress: number, chestProgress: { current: number; max: number } | number): this {
    const {
      layout: { levelText },
    } = this;

    levelText.text = getLocalizedValue(progress);
    this.updateProgressBar(
      typeof chestProgress === 'number' ? chestProgress : chestProgress.current / chestProgress.max,
    );
    return this;
  }

  public showTimer(): this {
    this.layout.timerContainer.visible = true;
    return this;
  }

  public hideTimer(): this {
    this.layout.timerContainer.visible = false;
    return this;
  }

  public updateTimerText(timeText: string): void {
    this.layout.timerText.text = timeText;
  }

  public setNotification(text: string | null): void {
    this.layout.notification.visible = text !== null;
    if (text === null) return;
    this.layout.notificationText.text = text;
  }

  private updateProgressBar(normValue: number): void {
    // map the value from 0-1 to 0.1-0.9
    // the progress bar is obscured by a value label
    // so we only show the circle progress from 10% to 90% as a result
    const adjustedValue = 0.1 + normValue * 0.8;
    this.progressBar.progress = Math.round(adjustedValue * 100);
  }

  private async startNotificationAnimation(): Promise<void> {
    const { notification } = this.layout;
    if (notification.destroyed) return;

    await notification.tweenTo({ scaleXY: 1.2 }, 200, 'sinOut', true, 0, 1, true).asyncOnComplete();
    await notification.wait(500);
    void this.startNotificationAnimation();
  }
}
